import template from './emailSend.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdDialog, $mdMedia, eventService, emailService, uiService) {
      'ngInject';
      /*
       * Controller model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.destroyWatch = eventService.onEmailSend((params) => {
          $mdDialog
            .show({
              targetEvent: params?.event || null,
              locals: {
                clients: params?.clients || [],
                contacts: params?.contacts || [],
                accounts: params?.accounts || [],
                partners: params?.partners || [],
                attachments: params?.attachments || [],
                messages: params?.messages || [],
                ticket: params?.ticket || {},
                contact: params?.contact || {}
              },
              template,
              controllerAs: '$ctrl',
              controller(
                clients,
                contacts,
                accounts,
                partners,
                attachments,
                messages,
                ticket,
                contact
              ) {
                const self = this;
                self.clients = _.filter(clients || [], (c) => c?.getEmail());
                self.idClients = _.map(self.clients, 'id');
                self.contacts = _.filter(contacts || [], (c) => c?.getEmail());
                self.idContacts = _.map(self.contacts, 'id');
                self.accounts = accounts;
                self.idAccounts = _.map(self.accounts, 'id');
                self.partners = partners;
                self.idPartners = _.map(self.partners, 'id');
                self.attachments = attachments;
                self.messages = messages;
                self.ticket = ticket;
                self.contact = contact;
                self.isOneRecipient = !_.isEmpty(self.contact);
                self.owner = _.find(
                  self.accounts,
                  (a) => a?.id === self.ticket?.idOwner || a?.id === self.contact?.idOwner
                );
                self.currentAccount = $rootScope.CurrentAccount;

                self.limit = 16;
                self.showMoreAttachments = false;

                self.email = {};
                self.email.subject = '';
                self.email.content = '';
                self.email.idSender = self.owner?.id;
                self.email.idClients = [];
                self.email.idContacts = [];
                self.email.idAccounts = [];
                self.email.idPartners = [];
                self.email.attachments = [];
                self.email.idWorkflow = self.ticket?.idWorkflow || '';
                self.email.idTicket = self.ticket?.id || '';
                self.email.idContact = self.contact?.id || '';

                self.isSenderDisabled = () => !self.ticket || _.isEmpty(self.ticket);

                self.canSend = () =>
                  self.isOneRecipient
                    ? self.email?.idContact
                    : self.email?.idClients?.length ||
                      self.email?.idContacts?.length ||
                      self.email?.idAccounts?.length ||
                      self.email?.idPartners?.length;

                self.toggleSenders = ({ type }) => {
                  if (type === 'clients') {
                    self.email.idClients = self.email?.idClients?.length ? [] : self.idClients;
                  }
                  if (type === 'contacts') {
                    self.email.idContacts = self.email?.idContacts?.length
                      ? []
                      : self.idContacts;
                  }
                  if (type === 'accounts') {
                    self.email.idAccounts = self.email?.idAccounts?.length
                      ? []
                      : self.idAccounts;
                  }
                  if (type === 'partners') {
                    self.email.idPartners = self.email?.idPartners?.length
                      ? []
                      : self.idPartners;
                  }
                };

                for (let a = 0; a < self.attachments.length; a += 1) {
                  self.attachments[a].isSelected = false;
                }

                self.addMessage = (message) => {
                  self.email.subject = message.subject;
                  self.email.content = message.content;
                };

                self.select = (selectedAttachment) => {
                  const attachment = selectedAttachment;
                  attachment.isSelected = !attachment.isSelected;
                  const idx = _.findIndex(
                    self.email.attachments,
                    (a) => a.id === attachment.id
                  );
                  if (idx === -1) {
                    self.email.attachments.push(attachment);
                  } else {
                    self.email.attachments.splice(idx, 1);
                  }
                };
                self.toggleShowMore = () => {
                  self.showMoreAttachments = !self.showMoreAttachments;
                  self.limit = self.showMoreAttachments ? undefined : 16;
                };

                self.confirm = () => {
                  if (self.email.subject && self.email.content) {
                    $mdDialog.hide(self.email);
                  } else {
                    uiService.toast({
                      text: {
                        p1: 'Email subject and content',
                        p2: 'are required fields',
                        p3: 'and cannot be empty'
                      },
                      warn: true
                    });
                  }
                };
                self.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then((result) => {
              const idContacts = _.compact(
                _.union(result?.idClients || [], result?.idContacts || [])
              );
              emailService
                .sendEmail({
                  idSender: result?.idSender || '',
                  idContacts,
                  idAccounts: result?.idAccounts || [],
                  idPartners: result?.idPartners || [],
                  idWorkflow: result?.idWorkflow || '',
                  idTicket: result?.idTicket || '',
                  idContact: result?.idContact || '',
                  subject: result?.subject || '',
                  content: result?.content || '',
                  attachments: result?.attachments || []
                })
                .then((res) => {
                  const data = {
                    status: res?.status,
                    subject: result?.subject || ''
                  };
                  ctrl.onFinished({ data });
                });
            });
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
